import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
html{
font-size: 10px;
}
`;

export default GlobalStyles;
